import React from "react";
import { Route, Switch } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import { path } from "../helpers/path";
import { roles } from "../helpers/constants";
import { appSelector } from "../helpers/appSelector";

import Dashboard from "../pages/_dashboard";
import Transactions from "../pages/_trans";
import BulkPayment from "../pages/_bulkPayment";
import bulkPaymentPage from "../pages/_bulkPaymentPage";
import PaymentPages from "../pages/_paymentPages";
import Page from "../pages/_[pageId]";
import Login from "../pages/_login";
import Pay from "../pages/_[pay]";
import GenericPay from "../pages/_[genericPay]";
import ExamplePay from "../pages/_examplePay";
import MerchantsOverview from "../pages/_merchantsOverview";
import MerchantsChannels from "../pages/_merchantsChannels";
import VASProcessed from "../pages/_vasProcessed";
import Settings from "../pages/_settings";
import FeeReports from "../pages/_feeReports";
import B2CTransactions from "../pages/_b2ctransactions";
import PendingTransactionsView from "../pages/_pendingTransactions";
import NotFound from "../pages/_404";
import ForgottenPassword from "../pages/_forgottenPassword";
import ResetPassword from "../pages/_reset-password";
import VasTransactions from "../pages/_vasTransactions";
import AllocateFunds from "../pages/_allocateFunds";
import PaymentFile from "../pages/_[fileId]";
import SocodeeTransactions from "../pages/_socodee";
import SnelTransactions from "../pages/_snel";
import BulkPaymentApproval from "../pages/_bulkPaymentApproval";

const Routes: React.FC = () => {
  const { user } = appSelector((state) => state.auth);

  const isSuperMerchant = user?.roles?.includes(roles.SuperMerchant) || false;

  return (
    <React.Fragment>
      <Switch>
        {/* Public routes */}
        <Route exact path={path.login} component={Login} />
        <Route exact path={path.forgottenPasssword} component={ForgottenPassword} />
        <Route exact path={path.resetPassword} component={ResetPassword} />
        <Route exact path={`${path.pay}/:processId`} component={Pay} />
        <Route exact path={`${path.payment}/:processId`} component={GenericPay} />
        <Route exact path={path.example} component={ExamplePay} />
        <Route exact path={path.bulkPaymentApproval} component={BulkPaymentApproval} />

        {/* Private routes for all authenticated users */}
        <PrivateRoute exact path={path.home} component={Dashboard} />
        <PrivateRoute exact path={path.dashboard} component={Dashboard} />
        <PrivateRoute exact path={path.tranasctions} component={Transactions} />
        <PrivateRoute exact path={path.bulkPayment} component={BulkPayment} />
        <PrivateRoute exact path={path.pendingPayments} component={bulkPaymentPage} />
        <PrivateRoute exact path={`${path.file}/:fileId`} component={PaymentFile} />
        <PrivateRoute exact path={path.paymentPages} component={PaymentPages} />
        <PrivateRoute exact path={`${path.page}/:pageId`} component={Page} />
        <PrivateRoute exact path={path.settings} component={Settings} />
        <PrivateRoute exact path={path.b2ctransactions} component={B2CTransactions} />
        <PrivateRoute exact path={path.vasTransactions} component={VasTransactions} />
        <PrivateRoute exact path={path.socodee} component={SocodeeTransactions} />
        <PrivateRoute exact path={path.snel} component={SnelTransactions} />
        <PrivateRoute exact path={path.pendingTransactions} component={PendingTransactionsView} />
        <PrivateRoute exact path={path.allocateFunds} component={AllocateFunds} />

        {/* SuperMerchant only routes */}
        {isSuperMerchant ? (
          <>
            <PrivateRoute exact path={path.merchantsOverview} component={MerchantsOverview} />
            <PrivateRoute exact path={path.merchantsChannels} component={MerchantsChannels} />
            <PrivateRoute exact path={path.vasProcessed} component={VASProcessed} />
            <PrivateRoute exact path={path.feeReports} component={FeeReports} />
          </>
        ) : (
          <>
            <Route path={path.merchantsOverview} component={NotFound} />
            <Route path={path.merchantsChannels} component={NotFound} />
            <Route path={path.vasProcessed} component={NotFound} />
            <Route path={path.feeReports} component={NotFound} />
          </>
        )}

        {/* Catch-all route - */}
        <Route component={NotFound} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
